import { INewsReponse } from "../../../model/base/response/news-response";
import { INewsCategoryResponse } from "../../../model/base/response/news-category-response";
import { Pagination } from "../../../model/paginatiion";

export enum ACTION_TYPES {
    SET_NEWS = 'SET_NEWS',
    SET_CATEGORIES = 'SET_CATEGORIES'
}

export interface INewsState {
    news: Pagination<INewsReponse>;
    categories: INewsCategoryResponse[];
}

export const initialState: INewsState = {
    news: new Pagination<INewsReponse>(),
    categories: []
};

export type Action =
    | { type: ACTION_TYPES.SET_NEWS; payload: Pagination<INewsReponse> }
    | { type: ACTION_TYPES.SET_CATEGORIES; payload: INewsCategoryResponse[] };

export const newsReducer = (state: INewsState, action: Action): INewsState => {
    switch (action.type) {
        case ACTION_TYPES.SET_NEWS:
            return { ...state, news: action.payload };
        case ACTION_TYPES.SET_CATEGORIES:
            return { ...state, categories: action.payload };
        default:
            throw new Error(`Unhandled action type`);
    }
};
